$(document).ready(function() {

  setTimeout(function(){
    $('#product-gallery-left').append('<div class="selectionpreview"><p><span><img class="blur-up lazypreload lazyloaded" width="100" src="https://cdn.shopify.com/s/files/1/0568/3275/3819/files/pulses.gif?v=1624004024" alt="Selection Preview"></span>Preview</p></div>');
  }, 1000);



  // Cache the highest
  var highestBox = 0;

  $('.swatch_option_select-background .swatch-element label span', this).each(function(){
    if($(this).height() > highestBox) {
      highestBox = $(this).height(); 
    }
  });  
  // Set the height of all those children to whichever was highest 
  $('.swatch_option_select-background .swatch-element label span',this).height(highestBox);


  /*
  var windowWidth = $(window).width();

  if (windowWidth <= 529) {

    $(window).scroll(function() {
      $('#product-gallery-left').removeClass("removestick");

      var top = $('.header_bot.sticky').outerHeight();
      var height = $('#product-gallery-left').outerHeight() + top;
      var bot = $("#tabing_pro").position();   

      if ($(this).scrollTop() < $('#product-gallery-left').offset().top) {
        $('#product-gallery-left').removeClass("stick");
        $('#product-gallery-left').css('top','0');
        $('#product_info_cus').removeClass("stick");
        $('#product_info_cus').css('margin-top','0');
      }
      if ($(this).scrollTop() >= $('#product-gallery-left').offset().top) {
        $('#product-gallery-left').addClass("stick");
        $('#product-gallery-left').removeClass("removestick");
        $('#product-gallery-left').css('top',top+'px');
        $('#product_info_cus').addClass("stick");
        $('#product_info_cus').css('margin-top',height+'px');
      }

      if ($(this).scrollTop() >= $('#tabing_pro').offset().top - 350) {
        $('#product-gallery-left').removeClass("stick");
        $('#product-gallery-left').css('top','0');
        $('#product_info_cus').removeClass("stick");
        $('#product_info_cus').css('margin-top','0');
      }


    });
  }
  */
});


$(document).ready(function() { 

  $('#infiniteoptions-container textarea').keyup(function(){
  });

  $("#infiniteoptions-container > textarea").click(function(){
    setTimeout(function(){
      $('#product-gallery-left').addClass("removestick");
    }, 1000);
  });

  $("#infiniteoptions-container").click(function(){
    console.log("drawing_notes was clicked.");
    setTimeout(function(){
      $('#product-gallery-left').addClass("removestick");
    }, 1000);
  });

  $("#infiniteoptions-container").on("tap",function(){
    console.log("drawing_notes was tap.");
    setTimeout(function(){
      $('#product-gallery-left').addClass("removestick");
    }, 1000);
  });


  var windowWidth = $(window).width();

  $(window).resize(function() {
    if (windowWidth > 530) {
      $('#product-gallery-left').removeClass("stick");
      $('#product-gallery-left').css('top','0');
    }
  });



  setTimeout(function(){
    //$('#uploadery-container input').attr('accept','image/*');
  }, 2000);

  var isFacebookApp = function () {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1 ) || (ua.indexOf("Instagram") > -1);
  };

  if (isFacebookApp()) {
    //alert('isFacebookApp');
    $('#uploadery-container input').removeAttr('accept');
  }



});


